
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-assessment-software",
      function () {
        return require("private-next-pages/talent-assessment-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-assessment-software"])
      });
    }
  